var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70%",
    height: "70%",
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3315 36.0672C28.2054 36.0672 36.2098 28.1831 36.2098 18.4574C36.2098 8.73183 28.2054 0.847656 18.3315 0.847656C8.45753 0.847656 0.453125 8.73183 0.453125 18.4574C0.453125 28.1831 8.45753 36.0672 18.3315 36.0672Z",
    fill: "#1100FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7612 36.0672C67.6351 36.0672 75.6395 28.1831 75.6395 18.4574C75.6395 8.73183 67.6351 0.847656 57.7612 0.847656C47.8872 0.847656 39.8828 8.73183 39.8828 18.4574C39.8828 28.1831 47.8872 36.0672 57.7612 36.0672Z",
    fill: "#1100FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3315 75.1239C28.2054 75.1239 36.2098 67.2397 36.2098 57.5141C36.2098 47.7885 28.2054 39.9043 18.3315 39.9043C8.45753 39.9043 0.453125 47.7885 0.453125 57.5141C0.453125 67.2397 8.45753 75.1239 18.3315 75.1239Z",
    fill: "#1100FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7612 75.1239C67.6351 75.1239 75.6395 67.2397 75.6395 57.5141C75.6395 47.7885 67.6351 39.9043 57.7612 39.9043C47.8872 39.9043 39.8828 47.7885 39.8828 57.5141C39.8828 67.2397 47.8872 75.1239 57.7612 75.1239Z",
    fill: "#1100FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.f4354e9b458244a33eae9af890f9a57f.svg";
export { ForwardRef as ReactComponent };